import { useEffect } from 'react';
import Checkbox from '../../Components/Checkbox';
import GuestLayout from '../../Layouts/GuestLayout';
import InputError from '../../Components/InputError';
import InputLabel from '../../Components/InputLabel';
import PrimaryButton from '../../Components/PrimaryButton';
import TextInput from '../../Components/TextInput';
import { Head, Link, useForm } from '@inertiajs/react';

export default function Login({ status, canResetPassword, company }) {
    const { data, setData, post, processing, errors, reset } = useForm({
        email: '',
        password: '',
        remember: false,
    });

    useEffect(() => {
        return () => {
            reset('password');
        };
    }, []);

    const submit = (e) => {
        e.preventDefault();

        post(route('login'), {
            onSuccess: (page) => {
                const tenant = page.props?.tenant || page.props?.auth?.user?.tenant || 'cnd-vi';
                localStorage.setItem('currentTenant', tenant);
            },
            onError: (errors) => {
                console.log(errors);
            },
        });
    };

    const labelStyle = {
        fontSize: '13px',
        fontWeight: '600',
        color: '#475569',
        marginBottom: '6px',
        display: 'block'
    };

    const inputStyle = {
        borderRadius: '8px',
        padding: '12px 16px',
        border: '1px solid #cbd5e1',
        fontSize: '14px',
        height: 'auto',
        boxShadow: 'none',
        transition: 'border-color 0.2s, box-shadow 0.2s',
        display: 'block',
        width: '100%'
    };

    return (
        <GuestLayout company={company}>
            <Head title="Log in" />

            {status && <div className="mb-4 font-medium text-sm text-green-600">{status}</div>}

            <form onSubmit={submit}>
                <div>
                    <InputLabel htmlFor="email" value="Email" style={labelStyle} />

                    <TextInput
                        id="email"
                        type="email"
                        name="email"
                        value={data.email}
                        autoComplete="username"
                        isFocused={true}
                        onChange={(e) => setData('email', e.target.value)}
                        style={inputStyle}
                    />

                    <InputError message={errors.email} className="mt-2" />
                </div>

                <div style={{ marginTop: '20px' }}>
                    <InputLabel htmlFor="password" value="Password" style={labelStyle} />

                    <TextInput
                        id="password"
                        type="password"
                        name="password"
                        value={data.password}
                        autoComplete="current-password"
                        onChange={(e) => setData('password', e.target.value)}
                        style={inputStyle}
                    />

                    <InputError message={errors.password} className="mt-2" />
                </div>

                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: '20px' }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Checkbox
                            name="remember"
                            checked={data.remember}
                            onChange={(e) => setData('remember', e.target.checked)}
                            style={{ position: 'static', margin: 0, width: '16px', height: '16px', borderRadius: '4px', cursor: 'pointer' }}
                        />
                        <label style={{ marginLeft: '8px', marginBottom: 0, fontSize: '13px', color: '#64748b', cursor: 'pointer', userSelect: 'none', fontWeight: '500' }} onClick={() => setData('remember', !data.remember)}>
                            Remember me
                        </label>
                    </div>

                    {canResetPassword && (
                        <Link
                            href={route('password.request')}
                            style={{
                                fontSize: '13px',
                                color: '#64748b',
                                textDecoration: 'none',
                                fontWeight: '500',
                                transition: 'color 0.2s'
                            }}
                            onMouseEnter={(e) => e.target.style.color = '#334155'}
                            onMouseLeave={(e) => e.target.style.color = '#64748b'}
                        >
                            Forgot your password?
                        </Link>
                    )}
                </div>

                <div style={{ marginTop: '24px' }}>
                    <PrimaryButton 
                        disabled={processing}
                        style={{
                            float: 'none',
                            width: '100%',
                            padding: '12px',
                            borderRadius: '8px',
                            fontWeight: '600',
                            fontSize: '15px',
                            backgroundColor: '#66cc33',
                            borderColor: '#66cc33',
                            color: '#ffffff',
                            boxShadow: '0 4px 10px rgba(102, 204, 51, 0.25)',
                            transition: 'all 0.2s',
                            border: '1px solid #66cc33'
                        }}
                    >
                        Log in
                    </PrimaryButton>
                </div>
            </form>
        </GuestLayout>
    );
}
